// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DelegateGroupedAlpImageVoteTable_wrapper__383Nz","alpCell":"DelegateGroupedAlpImageVoteTable_alpCell__2DFpr"};